var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "package-detail bg-white flex mdmax:flex-col shadow-border-b"
  }, [_c('div', {
    staticClass: "p-6 flex-1 shadow-border-r mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Rincian Layanan")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.packageDetail.id))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Layanan/Paket Layanan")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.packageDetail.name))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kode Layanan (Sistem saat ini)")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_external_code || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Deskripsi")]), _c('p', {
    staticClass: "text-neutral-500",
    domProps: {
      "innerHTML": _vm._s(_vm.packageDetail.description)
    }
  })]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tipe Layanan")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(" " + _vm._s(_vm.getDeliveryType(_vm.packageDetail.delivery_service_type)) + " ")])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Cost Mapping")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.packageDetail.cost_mapping_name))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Syarat & Ketentuan")]), _c('p', {
    staticClass: "text-neutral-500 tnc",
    domProps: {
      "innerHTML": _vm._s(_vm.packageDetail.tnc)
    }
  })])]), _c('div', {
    staticClass: "p-6 flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Status Kategori")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Status")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.packageDetail.status)))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kategori")]), _c('ul', {
    staticClass: "list-disc pl-5"
  }, _vm._l(_vm.packageDetail.package_goods_categories, function (category, index) {
    return _c('li', {
      key: 'category-' + index,
      staticClass: "text-neutral-500"
    }, [_vm._v(" " + _vm._s(category.category_name) + " ")]);
  }), 0)])])]), _c('div', {
    staticClass: "package-detail p-6 bg-white flex gap-4 justify-end items-center mdmax:flex-col"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete"
    },
    on: {
      "action": _vm.toggleDeleteConfirmation
    }
  }), _c('LinkButton', {
    attrs: {
      "buttonText": "Edit",
      "type": "secondary",
      "linkType": "internal",
      "url": `/package/update/${_vm.packageId}`
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteConfirmation,
      "width": "600px",
      "id": "delete-confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Hapus Layanan?")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Apakah Anda yakin untuk menghapus layanan ini? ")])])]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.confirmDelete();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }